import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './views/Home';
import { ScoreFormView } from './views/ScoreFormView';
import { MainLayout, LandingLayout } from './layouts';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { blue } from '@mui/material/colors';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { es } from 'date-fns/locale';
import { SuccessCard } from './components/SuccessCard';

const theme = createTheme({
    palette: {
        primary: {
            main: blue[400],
        },
        secondary: {
            main: '#F542A5',
        },
    },
});

const App = () => {
    return (
        <ThemeProvider theme={theme}>
            <LocalizationProvider
                dateAdapter={AdapterDateFns}
                adapterLocale={es}
            >
                <Router>
                    <Routes>
                        <Route element={<MainLayout />}>
                            <Route
                                exact
                                path="/:token"
                                element={<ScoreFormView />}
                            />
                            <Route
                                exact
                                path="/success"
                                element={<SuccessCard />}
                            />
                        </Route>
                        <Route element={<LandingLayout />}>
                            <Route exact path="*" element={<Home />} />
                        </Route>
                    </Routes>
                </Router>
            </LocalizationProvider>
        </ThemeProvider>
    );
};

export default App;
